import { render, staticRenderFns } from "./SiteCertificates.vue?vue&type=template&id=fae3b5b2&scoped=true"
import script from "./SiteCertificates.vue?vue&type=script&lang=js"
export * from "./SiteCertificates.vue?vue&type=script&lang=js"
import style0 from "./SiteCertificates.vue?vue&type=style&index=0&id=fae3b5b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae3b5b2",
  null
  
)

export default component.exports